import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { Customer, Company, Companytemplate, CompanyInfo } from '../customer.model';
import { CustomerService } from '../customer.service';
import { ErrorService } from '../../../common/errors/error.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-customer-company-create',
    templateUrl: './customer-company-create.component.html',
    styleUrl: './customer-company-create.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class CustomerCompanyCreateComponent {
  @Input() customer: Customer = {} as Customer;

  companies: Company[] = [];
  templates: Companytemplate[] = [];
  
  inputCompanyName: string = '';
  inputCompanyNameUrl: string = '';
  inputTemplateId: number = -1;
  // Sticky auto-derive: stop mirroring the URL from the name once the user edits the URL themselves.
  urlManuallyEdited: boolean = false;

  saveingCompany: boolean = false;
  formLoading: boolean = true;  

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private errorService: ErrorService
  ) { }


  async ngOnInit(): Promise<void> {
    this.formLoading = true;
    this.companies = await this.customerService.getCompanies(this.customer.customerId);
    this.templates = await this.customerService.getCompanyTemplates(this.customer.departmentId);
    this.templates.unshift({customerId: -1, customerName: '', companyId: -1, companyName: ''});
    this.formLoading = false;
  }

  canSave(): boolean
  {
    const encodedUrl = this.encodedNameUrl.toLocaleLowerCase();
    return this.inputCompanyName.trim() != ''
        && this.inputCompanyNameUrl.trim() != ''
        && this.inputTemplateId != -1
        // Navn (the URL) is the integration key and must be unique; display names may repeat (issue #95).
        && this.companies.filter(c => c.nameUrl.toLocaleLowerCase() == encodedUrl).length == 0;
  }

  onNameChanged(value: string)
  {
    this.inputCompanyName = value;
    if (!this.urlManuallyEdited)
    {
      this.inputCompanyNameUrl = value;
    }
  }

  onUrlChanged(value: string)
  {
    this.inputCompanyNameUrl = value;
    this.urlManuallyEdited = true;
  }

  /** Preview of what gets stored in Navn — plain text typed by the user, URI-encoded behind the scenes. */
  get encodedNameUrl(): string
  {
    return encodeURIComponent(this.inputCompanyNameUrl ?? '');
  }

  async saveCompany()
  {
    
   this.saveingCompany = true;

   if (this.inputTemplateId <= -1)
   {
      this.errorService.notify('Vælg venligst en skabelon');
      return;
   }
         
   const _template = this.templates[this.inputTemplateId];
   const companyinfo: CompanyInfo = { companyId: 0,
    customerId: this.customer.customerId,
    name: this.inputCompanyName,
    nameUrl: encodeURIComponent(this.inputCompanyNameUrl),
    template: _template};

    await this.customerService.createCompany(companyinfo)
    .then((value: CompanyInfo)  => {
      this.commonService.CustomerListChanged.emit(this.customer.customerId.toString());
      this.commonService.CompanyListChanged.emit('nytregnskab');
      this.toastrService.success('Regnskab oprettet: ' + value.name);      
      this.activeModal.close(value);
    })
    .catch((error: any) => {
      this.saveingCompany = false;
    });
    // this.activeModal.close(this.inputCompanyName);
  }

  setTemplateText(optionTemplate: Companytemplate): string
  {
    if (optionTemplate.customerId == -1)
    {
       return 'Vælg skabelon..';
    }
    else
    {
      if (optionTemplate.customerName != '')
      {
        return optionTemplate.customerName + ' [' + optionTemplate.customerId + '] - ' + optionTemplate.companyName + ' [' + optionTemplate.companyId + ']' ;
      }

      return optionTemplate.companyName + ' [' + optionTemplate.companyId + ']';
    }    
  }

  setValuesFromTemplate($event: any)
  {
    $event.preventDefault();
    if ($event.target.value && $event.target.value > -1)
    {
      this.inputTemplateId = $event.target.value;
    } 
  }
}
